import React from 'react';

import { useLandingV2Preview } from 'components/Pages/shared/hooks';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import LandingV2 from 'detailsv2/LandingV2';
import { BurgerMenu } from 'detailsv2/LandingV2/Header/TopBar/BurgerMenu';
import { ELandingDeviceType } from 'detailsv2/LandingV2/types';
import { IProposal } from 'utils/itineraryDetails/types';

import { iconsConfig } from '../../../Itinerary/Landing/V2/functions';
import LandingActions from '../../ItinerariesItemLanding/LandingActions';

function LandingV2Preview({ data, deviceType }: { data: IProposal; deviceType?: ELandingDeviceType }) {
  const { proposal, config } = useLandingV2Preview({
    data,
    additionalConfig: { guestFormDisabled: data.type === ITINERARIES_ITEM_TYPES.GUEST_PORTAL },
  });

  return (
    <LandingV2
      data={proposal}
      leftActions={<BurgerMenu />}
      rightActions={<LandingActions icons={iconsConfig} />}
      deviceType={deviceType}
      config={config}
      readonly
    />
  );
}

export default LandingV2Preview;
